//Third Party Dependencies
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import qs from 'qs';

//MHD General Purpose libraries
import ActiveErrors from '../../components/common/activeErrors';
import { SectionHeading } from '../../components/common/standardComponents';
import LoadingIndicator from '../../components/loadingIndicator';

//Specific Business and UI components
import * as routes from '../../routes';
import { clearActivePatient, lookupPatient, getPatientSchedulableOrders } from '../../actions/rd2RefactorActions';
import { useAppDispatch, useAppSelector } from '../../store';

const StartCreateCareOrderRedirector = (props: any) => {
    const dispatch = useAppDispatch();

    const config = useAppSelector((state) => state.config);
    const auth = useAppSelector((state) => state.auth);
    const activePatient = useAppSelector((state) => state.activePatient);

    const routePrefix = config.instance.routePrefix;

    const [alertMessage, setAlertMessage] = useState<string>("");
    const [showLoadingIndicator, setShowLoadingIndicator] = useState<boolean>(true);
    const [showAlert, setShowAlert] = useState<boolean>(false);

    const dismissAlert = () => {
        setShowAlert(false);
    }

    useEffect(() => {
        var params = qs.parse(props.history.location.search, { ignoreQueryPrefix: true }) as {
            pid?: string;
            pidtype?: string;
        };
        if (params.pid && params.pidtype) {
            let cleanPid = params.pid.trim();
            let cleanPidType = params.pidtype.trim();
            dispatch(clearActivePatient());
            loadPatientData(cleanPid, cleanPidType);
        }
        else {
            setShowAlert(true);
            setShowLoadingIndicator(false);
            setAlertMessage("Please provide a patient identitfier and patient identifier type.");
        }
    }, [])

    const loadPatientData = (pid: string, pidType: string) => {
        let promiseArray: Promise<any>[] = [];
        promiseArray.push(dispatch(lookupPatient(pid, pidType)));

        if (config.orderManagement.usesExternalOrders) {
            promiseArray.push(dispatch(getPatientSchedulableOrders(pid, pidType)));
        }

        Promise.all(promiseArray)
            .then((response: any) => {
                if (response?.error) {
                    setShowLoadingIndicator(false);
                }
                else {
                    dispatch(routes.createCareOrder(routePrefix));
                }
            });
    }

    return (
        <div>
            <ActiveErrors />
            <SectionHeading label="Create Followup Visit Order" />
            <Alert className="text-center" color="warning" isOpen={showAlert} toggle={dismissAlert}>
                {alertMessage}
            </Alert>
            {showLoadingIndicator &&
                <LoadingIndicator loadingMessage="Fetching Patient Data..." />
            }
        </div>
    )
}

export default StartCreateCareOrderRedirector;